import React, {Component} from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';

import 'sass/buyxxl.scss';

import HeaderXXL from 'components/XXL/HeaderXXL';

import LoginRedirect from '../../components/LoginRedirect';
import XXLFunctionsText from '../../components/XXL/XXLFunctionsText';

import PaymentOptionRadio from 'components/payment/PaymentOptionRadio';
import PaymentMethodRadio from 'components/payment/PaymentMethodRadio';
import PaymentForm from '../../components/payment/PaymentForm';

import {t, dt} from 'l10n';

import {getProfile, clearProfile} from 'reducers/buyXXL';
import {getCurrentUser} from 'reducers/currentUser';
import {paymentOrder} from "../../backend-helpers/payment";
import BankDetailsPopup from "../../components/modals/BankDetailsPopup";
import isEmpty from "lodash/isEmpty";
import {getPaymentText} from "reducers/main";
import {Helmet} from "react-helmet";

class PaymentOrder extends Component {
    constructor(props) {
        super(props);

        this.state = {
            t1: 'néant',
            t2: 'néant',
            paymentMethod: '',
            returnPath: '/',
            paymentInfo: '',
            isPaymentDialogOpen: false
        };

        this.onSuccess = this.onSuccess.bind(this);
    }

    componentDidMount() {
        let {getPaymentText, paymentText } = this.props;
        this.loadDependentData(this.props);
        let paymentSessionInfo
            try {
                paymentSessionInfo = JSON.parse(sessionStorage.getItem('paymentOrder'))
                if(paymentSessionInfo && paymentSessionInfo.id) {
                    this.setState({paymentInfo: paymentSessionInfo})
                    this.setState({isPaymentDialogOpen: true})
                }
            } catch (e) {
            console.log(e)
            }


        if (isEmpty(paymentText)) {
            getPaymentText(6);
        }

    }

    componentWillReceiveProps(nextProps) {
        this.loadDependentData(nextProps)
    }

    componentWillUnmount() {
        const { clearProfile } = this.props;
        clearProfile();
    }

    loadDependentData(props) {
        let {location, user, getProfile} = props;

        let {r: id, return_path} = queryString.parse(location.search);
        if (id && (!user || user.id != id)) {
            getProfile({id});
        }

        if (return_path) {
            this.setState({returnPath: return_path});
        }
    }

    onSuccess() {
        let {getCurrentUser} = this.props;

        getCurrentUser();
    }

    getTotalPrice = () => {
        const { t1, t2 } = this.state;

        const paymentPlans = [
            {value: 'néant', price: 0},
            {value: 'xxl60', price: 30},
            {value: 'xxl180', price: 75},
            {value: 'xxl365', price: 140}
        ];

        const tokenPlans = [
            {value: 'néant', price: 0},
            {value: 'wal220', price: 20},
            {value: 'wal600', price: 50},
            {value: 'wal1000', price: 75}
        ];

        const selectedPlan = paymentPlans.find(plan => plan.value === t1);
        const selectedTokens = tokenPlans.find(plan => plan.value === t2);

        const planPrice = selectedPlan ? selectedPlan.price : 0;
        const tokenPrice = selectedTokens ? selectedTokens.price : 0;

        return planPrice + tokenPrice;
    }

    renderTotalPrice = () => {
        const total = this.getTotalPrice();

        if (total === 0) {
            return null;
        }

        return (
            <div>

                <div className="total-price-block">
                    <span>{dt('xxl', 'Amount: ')}</span>
                    <p className="total-price">{dt('xxl', '%1 €', total)}</p>
                </div>

            </div>
        );
    }

    handleCreateOrder = async () => {
        let {t1, t2, message} = this.state;
        let {user} = this.props;
        let t = [];
        let amount = this.getTotalPrice();
        if (t1 !== 'néant') t.push(t1);
        if (t2 !== 'néant') t.push(t2);
        let receiver_id
        if (user && user.id) {
            receiver_id = user.id
        }
        try {
            const createOrderResponse = await paymentOrder({amount, t, receiver_id, message });

            if (createOrderResponse.result) {
                this.setState({paymentInfo: createOrderResponse.result});
                sessionStorage.setItem('paymentOrder', JSON.stringify(createOrderResponse.result));
                this.setState({isPaymentDialogOpen: true});
            }
        } catch (error) {
            console.error('Error creating order:', error);
        }
    }

    handleRedirectToCCPayment = () => {
        const {currentUser} = this.props;
        const {t1, t2} = this.state;

        const userId = currentUser ? currentUser.id : null;
        const email = currentUser ? currentUser.email : null;

        const paymentPlans = ['néant', 'xxl60', 'xxl180', 'xxl365'];
        const tokenPlans = ['néant', 'wal220', 'wal600', 'wal1000'];

        const dIndex = paymentPlans.indexOf(t1);
        const jIndex = tokenPlans.indexOf(t2);

        const packs = [
            dIndex > 0 ? `d${dIndex}` : null,
            jIndex > 0 ? `j${jIndex}` : null,
        ].filter(Boolean).join(',');

        const params = new URLSearchParams({
            s: 't',
            ...(userId && {user_id: userId}),
            ...(email && {email}),
            ...(packs && {packs}),
        });

        window.open(`https://moncloneia.fr/payment?${params.toString()}`, '_blank');
    }

    handleConfirm = () => {
        const {paymentMethod} = this.state;

        if (paymentMethod === 'bank') {
            this.handleCreateOrder();
        } else {
            this.handleRedirectToCCPayment();
        }
    }


    render() {
        let {currentUser, location, user, paymentText} = this.props;

        if (!currentUser.isLoggedIn()) {
            return <LoginRedirect location={location}/>
        }

        let {t1, t2, paymentMethod, message, returnPath} = this.state;

        const paymentMethods = [
            {value: 'cc', name: dt('xxl', 'Credit card')},
            {value: 'bank', name: dt('xxl', 'Bank transfer')},
        ];

        let paymentFormAdditionalData = {t, message};
        if (user) paymentFormAdditionalData.r = user.id;

        const paymentPlans = [
            {value: 'néant', name: 'néant', price: 0, freePoints: 0},
            {value: 'xxl60', name: dt('xxl', '%1 days', 60), price: 30, freePoints: 0},
            {value: 'xxl180', name: dt('xxl', '%1 days', 180), price: 75, freePoints: 0},
            {value: 'xxl365', name: dt('xxl', '%1 days', 365), price: 140, freePoints: 0}
        ];

        const tokenPlans = [
            {value: 'néant', price: 0, points: 0},
            {value: 'wal220', price: 20, points: 220},
            {value: 'wal600', price: 50, points: 600},
            {value: 'wal1000', price: 75, points: 1000}
        ]

        return (
            <div id="wrapper">
                <HeaderXXL>
                    {dt('xxl', 'Subscriptions & tokens')}
                </HeaderXXL>

                <Helmet>
                    <meta name="referrer" content="no-referrer"/>
                </Helmet>

                <aside className="buy-xxl">

                    <div className="content">


                        <h2 dangerouslySetInnerHTML={{
                            __html:
                                user ?
                                    dt('xxl', 'Choose what XXL plan you\'ll give to <strong>%1</strong>', user.nick) :
                                    dt('xxl', 'Choose your XXL plan')
                        }}/>

                        <div className="form-buy-xxl">

                            <div className="payment-options">
                                {paymentPlans.map((plan, index) =>
                                    <PaymentOptionRadio
                                        group={'membership'}
                                        value={plan.value}
                                        name={plan.price ? plan.name : 'néant'}
                                        price={plan.price}
                                        freePoints={plan.freePoints}
                                        checked={t1 === plan.value}
                                        onSelect={(value) => this.setState({t1: value})}
                                        key={index}
                                    />
                                )}
                            </div>


                            <div className="sub-header">
                                {/*{notEnoughBlock}*/}
                                <h2>{dt('xxl', 'Replenish your wallet')}</h2>
                            </div>

                            {!user && (<div className="payment-options">
                                {tokenPlans.map((plan, index) =>
                                    <PaymentOptionRadio
                                        group={'wallet'}
                                        value={plan.value}
                                        name={plan.points ? dt('xxl', "%1 tokens", plan.points) : 'néant'}
                                        price={plan.price}
                                        freePoints={plan.freePoints}
                                        checked={t2 === plan.value}
                                        onSelect={(value) => this.setState({t2: value})}
                                        key={index}
                                    />
                                )}
                            </div>)}


                        <div className="payment_type">
                            <div className="sub-header">
                                {/*{notEnoughBlock}*/}
                                <h2>{dt('xxl', 'Choose your payment')}</h2>
                            </div>

                            <div className="payment-method-options">
                                {paymentMethods.map((method, index) =>
                                    <PaymentMethodRadio
                                        value={method.value}
                                        name={method.name}
                                        checked={paymentMethod === method.value}
                                        onSelect={(value) => this.setState({paymentMethod: value})}
                                        key={index}
                                    />
                                )}
                            </div>

                        </div>

                            {user &&
                                <div className="message-block">
                                    <p>{dt('xxl', 'You can attach a message to %1, if you want:', user.nick)}</p>
                                    <textarea name="message"
                                              onChange={(e) => this.setState({message: e.target.value})}/>
                                </div>
                            }

                            <div>{this.renderTotalPrice()}</div>

                            <div style={{textAlign: 'right', color: '#770000', fontWeight: 'bold'}}>{((t2 !== 'néant' || t1 !== 'néant') && !paymentMethod) ? dt('xxl', 'Please select a payment method') : ''}</div>

                            <div className="button-block-order">
                                <p></p>
                                <div>
                                    <p
                                        onClick={() => {
                                            this.setState({t1: 'néant', t2: 'néant', paymentMethod: ''});
                                        }}

                                    >{dt('xxl', 'Reset')}</p>
                                    <button type="button"
                                            className="btn-submit"
                                            style={{
                                                opacity: (t2 !== 'néant' || t1 !== 'néant') && paymentMethod ? 1 : 0.4,
                                                cursor: (t2 !== 'néant' || t1 !== 'néant') && paymentMethod  ? 'pointer' : 'unset',
                                                pointerEvents: (t2 !== 'néant' || t1 !== 'néant') && paymentMethod  ? 'unset' : 'none',
                                            }}
                                            onClick={this.handleConfirm}

                                    >{dt('xxl', 'Confirm your choice')}</button>
                                </div>
                            </div>

                            <XXLFunctionsFoldable/>


                            <div className="content contentPaddings" dangerouslySetInnerHTML={{__html: paymentText}}/>

                            {/*<PaymentForm*/}
                            {/*    currentUser={currentUser}*/}
                            {/*    backendFn={paymentMembership}*/}
                            {/*    additionalData={paymentFormAdditionalData}*/}
                            {/*    onSuccess={this.onSuccess}*/}
                            {/*    returnPath={returnPath}*/}
                            {/*/>*/}
                        </div>

                    </div>
                </aside>
                <BankDetailsPopup
                    isOpen={this.state.isPaymentDialogOpen}
                    onClose={() => {
                        this.setState({isPaymentDialogOpen: false});
                        sessionStorage.removeItem('paymentOrder');
                    }}
                    orderDetails={this.state.paymentInfo}
                    user={user}
                />

            </div>
        )
    }
}


class XXLFunctionsFoldable extends Component {
    constructor(props) {
        super(props);

        this.state = {expanded: false}
    }

    render() {
        let {expanded} = this.state;

        return (
            <div className={'fonctionsXXL' + (expanded ? ' expanded' : '')}>
                <div className="controls" onClick={() => this.setState({expanded: !expanded})}>
                    <p>{dt('xxl', 'More information about Functions XXL')}</p>
                    <a className="toggle">
                        {expanded ? '−' : '+'}
                    </a>
                </div>
                <aside className="block-fonctions-xxl">
                    <XXLFunctionsText className="text" showLink={false}/>
                </aside>
            </div>
        )
    }
}

export default connect(
    state => ({
        currentUser: state.currentUser,
        user: state.buyXXL.user,
        paymentText: state.main ? state.main.payment_description : null,
    }),
    {
        getProfile,
        getCurrentUser,
        clearProfile,
        getPaymentText
    }
)(PaymentOrder)


// WEBPACK FOOTER //
// ./src/containers/member/PaymentOrder.js